<template>
    <div class="header">
        <el-menu
            :default-active="activeIndex"
            class="menu"
            mode="horizontal"
            :ellipsis="false"
            @select="handleSelect"
        >
            <el-menu-item index="1">Manual Labeling</el-menu-item>
            <el-sub-menu index="2">
                <template #title>AI-assisted Labeling</template>
                <el-menu-item index="2-1" class="elmenu2">  <img style="margin-right: 10px;" src="@/assets/images/menu_upload.png" alt="">  Upload</el-menu-item>
                <el-menu-item index="2-2" class="elmenu2" >  <img style="margin-right: 10px;" src="@/assets/images/menu_review.png" alt="">  Review</el-menu-item>
             </el-sub-menu>
        </el-menu>
        <el-dropdown style="--el-color-primary:#3AC0CB;">
            <span class="el-dropdown-link">
                Welcome {{ $store.state.user.doctorName }}
                <el-icon class="el-icon--right">
                    <arrow-down />
                </el-icon>
            </span>
            <template #dropdown>
            <el-dropdown-menu style="--el-color-primary:#3AC0CB; width: 120px;text-align: center;">
                <el-dropdown-item style="padding-left: 20px;" @click="logOut">Logout</el-dropdown-item>
            </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>

<script>
export default {
  name: 'headerH',
  data () {
    return {
      activeIndex: '1',
      username: '康醫生'
    }
  },
  methods: {
    handleSelect (e) {
      this.$emit('changeLabelModel', e)
    },
    logOut () {
      this.$emit('logoutSave')
    }
  }
}
</script>

<style lang="less" scoped>
.header{
    width: 100%;
    height: 50px;
    background-color: #3AC0CB;
    display: flex;
    justify-content: space-between;
    .menu{
        // width: 800px;
        flex:1;
        height: 50px;

    }
    .el-menu--horizontal>.el-menu-item.is-active{
        border-bottom: 0px !important;
        color: #000000!important;
        background-color: #75D3DB;
    }
    .el-menu--horizontal>.el-menu-item{
        color:#000000!important;
        background-color: #3AC0CB;
        border-bottom: 0px !important;
        // font-size: 16px;
        width:21.9%;
    }
    .el-menu--horizontal>.el-menu-item:hover{
        color:#000000!important;
        background-color: #75D3DB;

    }
    .el-sub-menu{
        width:21.9%;
    }
    .el-menu--horizontal{
        border-bottom:0px!important;
    }
    .el-menu{
        background-color:  #3AC0CB;
        // font-size: 16px;
    }
    .el-dropdown-link {
        cursor: pointer;
        color: #000000;
        display: flex;
        align-items: center;
        // font-size: 16px;
        border-color: #3AC0CB!important;
    }
    .el-dropdown:fo{
        border-color: #3AC0CB!important;
    }
    @media screen and (max-width:1401px){
        .el-menu-item,.el-sub-menu{
            //   width: 279px;
              font-size: 16px;
        }

    }
    @media screen and (min-width:1401px) and (max-width:1441px){
        .el-menu-item,.el-sub-menu{
            //   width: 288px;
              font-size: 16px;
        }
    }
    @media screen and (min-width:1441px) and (max-width:1600px){
        .el-menu-item,.el-sub-menu{
            //   width: 323px;
              font-size: 18px;
        }
    }
    @media screen and (min-width:1601px) and (max-width:1680px){
        .el-menu-item,.el-sub-menu{
            //   width: 341px;
              font-size: 18px;
        }
    }
    @media screen and (min-width:1681px){
        .el-menu-item,.el-sub-menu{
            //   width: 393px;
              font-size: 20px;
        }
    }

}
</style>
<style lang="less" >
.header{
    .el-menu--horizontal>.el-sub-menu .el-sub-menu__title:hover{
        background-color:  #75D3DB!important;
    }
    .el-menu--horizontal>.el-sub-menu .el-sub-menu__title{
        // font-size: 16px;
        justify-content: center;
    }
    .el-menu--horizontal>.el-sub-menu:hover .el-sub-menu__title{
        color: #000000!important;
    }
    .el-menu--horizontal>.el-sub-menu.is-active .el-sub-menu__title{
        border-bottom: 0px !important;
        color: #000000!important;
        background-color:  #75D3DB!important;
    }
    .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal{
        .el-menu {
            .el-sub-menu__title{
                justify-content: center;
                // font-size: 16px;
            }
            .el-menu-item.is-active, .el-sub-menu.is-active>.el-sub-menu__title{
                // color: #000000 !important;
            }
            .el-sub-menu .el-menu-item{
                color: #000000 !important;
                // font-size: 16px;
            }
        }

    }

}
.el-menu--horizontal .el-menu .el-menu-item.is-active, .el-menu--horizontal .el-menu .el-sub-menu.is-active>.el-sub-menu__title{
        color: #000000 !important;
        background-color: #75D3DB!important;
    }
    .el-menu--horizontal .el-menu .el-menu-item:not(.is-disabled):hover,.el-menu--horizontal .el-menu .el-menu-item:not(.is-disabled):focus{
        color:#000000!important;
        // background-color: #75D3DB;

    }

    .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-sub-menu__title{
        justify-content: center;
        // font-size: 16px;
    }

    @media screen and (max-width:1401px){
        .el-menu--horizontal>.el-sub-menu .el-sub-menu__title{
            font-size: 16px;
        }
        .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-sub-menu__title{
            font-size: 16px;
            width: 279px;
        }

    }
    @media screen and (min-width:1401px) and (max-width:1441px){
        .el-menu--horizontal>.el-sub-menu .el-sub-menu__title{
            font-size: 16px;

        }
        .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-sub-menu__title{
            font-size: 16px;
              width: 288px;
        }
    }
    @media screen and (min-width:1441px) and (max-width:1600px){
        .el-menu--horizontal>.el-sub-menu .el-sub-menu__title{
            font-size: 18px;
        }
        .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-sub-menu__title{
              font-size: 18px;
              width: 323px;
        }
    }
    @media screen and (min-width:1601px) and (max-width:1680px){
        .el-menu--horizontal>.el-sub-menu .el-sub-menu__title{
            font-size: 18px;
        }
        .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-sub-menu__title{
              font-size: 18px;
              width: 341px;
        }
    }

    @media screen and (min-width:1681px){
        .el-menu--horizontal>.el-sub-menu .el-sub-menu__title{
            font-size: 20px;
        }
        .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-sub-menu__title{
              font-size: 18px;
              width: 393px;
            // width: 24.5625rem;

        }
    }

</style>
